module.exports = __webpack_public_path__ + "static/media/cuperhidro.d6530deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/xanthomonas_pimiento/preventiva/cuperhidro.png
// module id = 2210
// module chunks = 3